import React from "react";
import { StyledButton } from "components/molecules/Button/Button.styles";

const Button = ({
  children,
  gap,
  lg,
  sm,
  outline,
  variant,
  width,
  loader,
  disabled,
  danger,
  gray,
  ...rest
}) => {
  return (
    <StyledButton
      $lg={lg}
      $sm={sm}
      $outline={outline}
      $variant={variant}
      $danger={danger}
      $gray={gray}
      $gap={gap}
      $width={width}
      disabled={loader || disabled}
      {...rest}>
      {loader ? <span class="loader"></span> : children}
    </StyledButton>
  );
};

export default Button;
